import script from "./DialRadialBarSparkline.vue?vue&type=script&setup=true&lang=js"
export * from "./DialRadialBarSparkline.vue?vue&type=script&setup=true&lang=js"

import "./DialRadialBarSparkline.vue?vue&type=style&index=0&id=ad58da2c&lang=css"

const __exports__ = script;

export default __exports__